var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ts-input',_vm._g(_vm._b({staticClass:"ts-search-bar",attrs:{"size":"mini","prefix-icon":"el-icon-search"}},'ts-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }